export default __webpack_public_path__ + "static/media/men.b0abf6a7.svg";